import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import UserInfoHOC from '#components/HOC/UserInfoHOC'
import Avatar from '#components/a/Avatar'
import KapitelIcon from '#components/svg/icons/NavAusbildungsplan'
import StyledText from '#components/a/StyledText'
import {routeHelper} from '#config/routeKeys'
import {useAusbildungsplan} from '#hooks/useAusbildungsplan'

export function KapitelEinreichenBenachrichtigung(props) {
  const {userInfo, onNotificationClick, senderId, kapitelId} = props
  const {getTitleForChapter} = useAusbildungsplan(userInfo.id)
  const getKapitelName = () => getTitleForChapter(props.kapitelId)

  const text = i18n.t('notification_text_kapitel_einreichen', [
    `${userInfo.lastname}, ${userInfo.firstname}`,
    getKapitelName(),
  ])

  function onClickNotification() {
    onNotificationClick(routeHelper.ausbildungsplanQuestionsChapter(senderId, kapitelId))
  }

  return (
    <div
      role="button"
      tabIndex={0}
      className="notification"
      onClick={onClickNotification}
      onKeyPress={onClickNotification}
    >
      <Avatar profileImage={userInfo.profileImage} />
      <StyledText text={text} modifier="notification" />
      <div className="notification__icon notification__icon--right">
        <KapitelIcon />
      </div>
    </div>
  )
}

KapitelEinreichenBenachrichtigung.propTypes = {
  userInfo: PropTypes.shape({
    firstname: PropTypes.string,
    lastname: PropTypes.string,
    profileImage: PropTypes.string,
    id: PropTypes.number,
  }).isRequired,
  senderId: PropTypes.number.isRequired,
  kapitelId: PropTypes.string.isRequired,
  onNotificationClick: PropTypes.func.isRequired,
}

export default UserInfoHOC(KapitelEinreichenBenachrichtigung, ['senderId'])
